<template>
    <SearchComponent></SearchComponent>
</template>

<script>
import SearchComponent from '@/components/search/Search.vue';

export default {
    name: 'search',
    components: {
        SearchComponent,
    },
};
</script>

<style scoped lang="scss">
</style>
